// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header {\n\tflex: 0 1 auto;\n\tposition: relative;\n}", ""]);
// Exports
module.exports = exports;
